// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const MinusIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Minus/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 10a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
  clipRule: "evenodd"
}));
export default MinusIcon;